// useAlertDialog.jsx
import { useState, useCallback } from 'react';

const useAlertDialog = () => {
  const [dialogState, setDialogState] = useState({
    isOpen: false,
    title: '',
    content: '',
    buttonOne: '',
    buttonTwo: '',
    onAccept: () => {},
    onClose: () => {},
  });

  const openDialog = useCallback((title, content, onAccept=closeDialog, onClose=closeDialog, buttonOne='Ok', buttonTwo=null) => {
    setDialogState({
      isOpen: true,
      title,
      content: content,
      buttonOne,
      buttonTwo,
      onAccept: onAccept,
      onClose,
    });
  }, []);

  const closeDialog = useCallback(() => {
    setDialogState((prevState) => ({
      ...prevState,
      isOpen: false,
    }));
  }, []);

  return {
    dialogState,
    openDialog,
    closeDialog,
  };
};

export default useAlertDialog;
